import { render, staticRenderFns } from "./SpaceSettingsAccess.vue?vue&type=template&id=7093b644&"
import script from "./SpaceSettingsAccess.vue?vue&type=script&lang=js&"
export * from "./SpaceSettingsAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports